import React from 'react';
import { BsPlus } from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { Box, Button, Flex, Icon } from '@chakra-ui/react';

import { buttonBaseStyle } from '../../../../components/TabMenu/TabButton';
import { CypressIds } from '../../../../constants/cypressIds';
import { inAppText } from '../../../../constants/inAppText';
import { showModal } from '../../../../redux/modules/modal';
import radii from '../../../../styles/theme/foundation/radii';
import CreateUpdateFolderModal from '../modals/CreateUpdateFolderModal';

const CreateNewFolderTab = () => {
  const dispatch = useDispatch();
  const description = inAppText.templatesPage.folderMenu.createNewFolderModalMessage;

  const showNewFolderModal = () => {
    dispatch(showModal(() => <CreateUpdateFolderModal description={description} />, {
      title: 'New Folder',
      size: 'lg'
    }));
  };

  return (
    <Box
      borderRadius={`${radii.md} ${radii.md} 0px 0px`}
      style={buttonBaseStyle}
      onClick={showNewFolderModal}
    >
      <Button
        as={Flex}
        data-cy={CypressIds.reqTemplatesCreateNewFolderButton}
        justifyContent="flex-start"
        leftIcon={<Icon as={BsPlus} boxSize="20px" />}
        px={0}
        textAlign="left"
        variant="textPrimary"
        width="100%"
      >
        Create New Folder
      </Button>
    </Box>

  );
};

export default CreateNewFolderTab;
